import {
  MisconfigCellRenderer,
  NameCellRenderer,
  SecurityScoreCellRenderer,
  VendorTypeCellRenderer,
} from "../cell_renderers";
import { TABLE_INFO } from "../shared/table_config";

const { HEADER_LABEL: tableHeader, PROPS: tableProps } =
  TABLE_INFO.ONPREM_LOWEST_SCORE;

export const onPremLowestScoresColumnDefs = [
  {
    headerName: tableHeader.NAME,
    field: tableProps.NAME,
    flex: 5,
    filter: false,
    lockPosition: true,
    lockPinned: true,
    cellRenderer: NameCellRenderer,
    cellRendererParams: {
      fieldMapping: {
        ...tableProps,
      },
    },
    enableSorting: true,
    sortable: true,
    unSortIcon: true
   
  },
  {
    headerName: "Vendor-Type",
    field: "vendor",
    flex: 3,
    cellRenderer: VendorTypeCellRenderer,
    filter: false,
    sortable: true,
    enableSorting: true,
    unSortIcon: true
  },
  {
    headerName: tableHeader.SCORE,
    field: tableProps.SCORE,
    flex: 2.2,
    cellRenderer: SecurityScoreCellRenderer,
    filter: false,
    sortable: true,
    enableSorting: true,
    unSortIcon: true,
    // sort: "asc"
  },
  {
    headerName: tableHeader.MISCONFIGURATION,
    field: tableProps.MISCONFIGURATION,
    flex: 2.3,
    cellRenderer: MisconfigCellRenderer,
    filter: false,
    sortable: true,
    // sort:"asc",
    enableSorting: true,
    unSortIcon: true
  },
];
